import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Http } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #795548 0%, #5D4037 100%)",
    boxShadow: "0 4px 12px rgba(121, 85, 72, 0.4)",
    border: "2px solid #795548",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(121, 85, 72, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
    maxHeight: 100,
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  nodeMeta: {
    fontSize: 11,
    opacity: 0.9,
    marginTop: theme.spacing(0.5),
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #795548",
    borderRadius: "50%",
  },
}));

const HTTPRequestNode = ({ data, selected }) => {
  const classes = useStyles();
  const url = data?.url || data?.label || "HTTP Request";
  const method = data?.method || "GET";

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(121, 85, 72, 0.6)"
          : "0 4px 12px rgba(121, 85, 72, 0.4)",
      }}
    >
      <NodePorts color="#795548" />
      <Box className={classes.nodeHeader}>
        <Http className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>HTTP Request</Typography>
      </Box>
      <Box className={classes.nodeContent}>
        {url.length > 40 ? `${url.substring(0, 40)}...` : url}
      </Box>
      <Typography className={classes.nodeMeta}>
        Método: {method}
      </Typography>
    </Box>
  );
};

export default HTTPRequestNode;
